module.exports = __webpack_public_path__ + "media/images/icon__compete@3x-b4729155d8d2f672854f00cbeea377ae.png";